import localFont from 'next/font/local'
import blockchainConfig from '@/config.json'
import { mainNetwork } from '@/components/Context'

export const uni1d800 = localFont({
    src: './Uni1D800Suttonsignwriting.ttf',
    display: 'swap',
})

export const nonBreakingSpace = '\u00A0'

export const copyToClipboard = async (text: string | undefined, setShowAnyTooltip: Function) => {
    if (!text) {
        return
    }
    try {
        await navigator.clipboard.writeText(text)
        setShowAnyTooltip(true)
        setTimeout(() => setShowAnyTooltip(false), 5000)
    } catch (err) {
        console.error('Failed to copy: ', err)
    }
}

export const custodial: string = blockchainConfig[`${mainNetwork.chainId}`].custodial.address.toLowerCase()
